import { ButtonLink } from "@/components/system";

/** Closing actions on Access Report pages. Claim requests go through each profile's claim prompt. */
export function ReportCtas() {
  return (
    <nav className="ds-cluster ds-report-ctas" aria-label="Access Report actions">
      <ButtonLink to="/directory">Find your listing to claim it</ButtonLink>
      <ButtonLink to="/directory" variant="secondary">Report a wait</ButtonLink>
      <ButtonLink to="/brief" variant="secondary">Subscribe to the brief</ButtonLink>
    </nav>
  );
}
